import { z } from 'zod';
/**
 * Quests (ADR 0047). The client names a quest and the townsperson it stands
 * by; the server checks the distance, the region, what is asked, and does
 * the rest. The state it sends back is the whole journal, to its owner alone.
 */
const QuestIdSchema = z.string().min(1).max(32);
/** A townsperson's entity id in the room's state (`mobs`), not its creature id. */
const NpcIdSchema = z.string().min(1).max(64);
export const QuestsRequestSchema = z.object({}).strict();
export const QuestAcceptMessageSchema = z.object({ questId: QuestIdSchema, npcId: NpcIdSchema });
/** A word with a townsperson: every quest objective they answer is flagged. */
export const QuestTalkMessageSchema = z.object({ npcId: NpcIdSchema });
export const QuestTurnInMessageSchema = z.object({ questId: QuestIdSchema, npcId: NpcIdSchema });
export const QuestAbandonMessageSchema = z.object({ questId: QuestIdSchema });
const ProgressSchema = z.object({
    value: z.number().int().min(0),
    target: z.number().int().min(1),
});
/** The journal, whole: the quests under way with each objective's count, and those turned in. */
export const QuestsEventSchema = z.object({
    active: z.array(z.object({
        id: QuestIdSchema,
        progress: z.array(ProgressSchema),
        /** Indices of the `talk` and `reach` objectives done, so the client can tell a word apart. */
        flags: z.array(z.number().int().min(0)),
    })),
    done: z.array(QuestIdSchema),
});
/** To the owner, as it is turned in: what it paid. */
export const QuestCompletedSchema = z.object({
    questId: QuestIdSchema,
    xp: z.number().int().min(0),
    gold: z.number().int().min(0),
    items: z.array(z.object({ templateId: z.string().min(1), quantity: z.number().int().min(1) })),
});
/** To the owner, as a bait is laid (ADR 0047): what came out of the den. */
export const BaitLaidSchema = z.object({ mobId: z.string().min(1) });
export const QUEST_REFUSALS = [
    'invalid',
    'unknown',
    'too-far',
    'wrong-npc',
    'done',
    'active',
    'locked',
    'level',
    'full',
    'not-active',
    'not-done',
    'bag-full',
    'busy',
    /** A lesson of the camp is never abandoned (ADR 0078). */
    'prologue',
];
export const QuestRejectedSchema = z.object({ reason: z.enum(QUEST_REFUSALS) });
//# sourceMappingURL=quests.js.map